import { gsap } from 'gsap/dist/gsap'
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

// gsap.registerPlugin(ScrollToPlugin) p

export default {
  init() {
  
    /**************************************************************
    -> Scroll down to the content after filters are clicked
    **************************************************************/
    // function scrollToContent() {
    //   const targetElement = document.querySelector('[data-content]')
    //   const filters = Array.from(document.querySelectorAll('.facetwp-radio'))

    //   filters.forEach(filter => {
    //     filter.addEventListener('click', () => {
    //       gsap.to(window, {scrollTo: { y: targetElement, offsetY: 100 }, duration: 2, ease: 'power2.inOut', overwrite: true})
    //     })
    //   })
      
    // }

    // $(document).on('facetwp-loaded', function() {
    //   scrollToContent()
    // });

    /**************************************************************
    -> Hide sections that don't have any posts
    **************************************************************/
   function hideEmptySections() {
     $(document).on('facetwp-loaded', function() {
      const featured = document.querySelector('section.featured')
      const featuredPosts = Array.from(featured.querySelectorAll('.card'))
      const recent = document.querySelector('section.recent')
      const recentPosts = Array.from(recent.querySelectorAll('.card'))

      if (featuredPosts.length === 0) {
        featured.classList.add('hidden')
      } else {
        featured.classList.remove('hidden')
      }
      
      if (recentPosts.length === 0) {
        recent.classList.add('hidden')
      } else {
        recent.classList.remove('hidden')
      }
    })
   }

   hideEmptySections()

    /**************************************************************
    -> Animate items when filtered
    **************************************************************/
    $(document).on('facetwp-loaded', function() {
      gsap.fromTo('.card', {
        opacity: 0,
      },
      { 
        opacity: 1,
        duration: 1,
        ease: 'linear',
        stagger: { // wrap advanced options in an object
          each: 0.15,
          from: 'start',
          // grid: 'auto',
          ease: 'linear',
        },
      })
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/template-articles.js